import { ImageTemplateComposer } from "@/_component/shared";
import { MediaRenderer, Ratings } from "@/_component/Common";
import { useAuthContext, useLanguageContext } from "@/hooks";

type StoryPreviewCardProps = {
  title: string;
  story: string;
  previewImageUrl: string;
  mediaList: Array<any>;
  rating?: number;
  showRating?: boolean;
};

export default function StoryPreviewCard({
  title,
  story,
  previewImageUrl,
  mediaList,
  rating = 0,
  showRating = false,
}: StoryPreviewCardProps) {
  const { user } = useAuthContext();
  const { language } = useLanguageContext();

  return (
    <div className="">
      <div className="position-relative text-center">
        <img
          src={previewImageUrl}
          alt="Final story preview"
          className="img-fluid mb-3 rounded"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>

      <div className="card-body">
        <div className="d-flex gap-3 align-items-center">
          <div>
            <i className="bi bi-person-circle fs-2"></i>
          </div>
          <div>
            <div className="text-dark text-bold fs-5">
              {user?.name || language("label.user") || "User"}
            </div>
            {showRating && <Ratings value={rating} readOnly />}
          </div>
        </div>
        <div className="mt-3">
          <div className="text-dark fs-4 text-bold">{title}</div>
          <div>{story}</div>
        </div>
      </div>

      {mediaList?.length > 0 && (
        <div className="d-flex gap-2 flex-wrap p-2">
          {mediaList?.map((media: any, index: number) => (
            <div className="border shadow-sm" key={media?.id || index}>
              <MediaRenderer width={"6rem"} height={"6rem"} media={media} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
